import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-device26",
  "use": "icon-device26-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-device26\"><path d=\"M512 185.6c-76.8 0-140.8 64-140.8 140.8v32h-44.8c-19.2 0-32 12.8-32 32v300.8c0 19.2 12.8 32 32 32h364.8c19.2 0 32-12.8 32-32V390.4c0-19.2-12.8-32-32-32h-38.4v-32c0-76.8-64-140.8-140.8-140.8zM428.8 326.4c0-44.8 32-76.8 76.8-76.8s76.8 32 76.8 76.8v32H428.8v-32z m230.4 96v236.8H358.4V422.4h300.8z\" fill=\"\" p-id=\"10717\" /><path d=\"M998.4 128C704-38.4 320-38.4 25.6 128c-6.4 6.4-12.8 19.2-12.8 32L32 384c0 19.2 19.2 32 32 32 19.2 0 32-19.2 32-32l-19.2-211.2C345.6 25.6 678.4 25.6 947.2 172.8l-38.4 448c-12.8 153.6-281.6 288-390.4 332.8C403.2 908.8 140.8 768 128 620.8c0-19.2-19.2-32-32-32-32 6.4-44.8 19.2-38.4 38.4 19.2 230.4 428.8 390.4 448 396.8h25.6c19.2-6.4 422.4-166.4 448-396.8l44.8-467.2c-12.8-12.8-19.2-25.6-25.6-32z\" fill=\"\" p-id=\"10718\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-device26.svg
// module id = ZVxY
// module chunks = 175